import { Controller } from "@hotwired/stimulus"

// Applies CSS zoom to a target element when container width falls below a threshold
// Useful for responsive scaling of fixed-width content
export default class extends Controller {
  static targets = ["content"]
  static values = {
    minWidth: { type: Number, default: 573 }
  }

  connect() {
    this.observe()
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  observe() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.updateZoom(entry.contentRect.width)
      }
    })

    this.resizeObserver.observe(this.element)
  }

  updateZoom(containerWidth) {
    if (containerWidth < this.minWidthValue) {
      const zoom = containerWidth / this.minWidthValue

      this.contentTarget.style.zoom = zoom
      this.element.dataset.zoomed = "true"
      this.contentTarget.style.width = `${this.minWidthValue}px`
    } else {
      this.contentTarget.style.zoom = ""
      this.element.dataset.zoomed = "false"
      this.contentTarget.style.width = ""
    }
  }
}

